var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261,
    height: 131,
    viewBox: "0 0 261 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 131,
    transform: "translate(0.867)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-0.867)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.608,0l-4,1.07,6.859,25.55,4-1.07Z",
    transform: "translate(-56.448 0)",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.306.745A4.9,4.9,0,0,1,232.6,3.725,11.139,11.139,0,0,1,227.613,2.3a12.591,12.591,0,0,0-5.761-1.45,12.347,12.347,0,0,0-7.864,2.935l3.427,12.767c1.772-2.459,3.343-4.754,8.8-4.754.641,0,1.334.032,2.089.1q.719.064,1.367.063C239.815,11.963,237.306.745,237.306.745Z",
    transform: "translate(-59.634 -0.21)",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.662,43.673c8.553-.62,14.5,2.513,20.241,5.544,5,2.638,10.173,5.366,16.728,5.366,7.987,0,14.43-4.084,21.252-8.408,7.674-4.865,15.61-9.9,26.8-9.9,32.2,0,90.235,47.852,90.817,48.336l2.649-3.181a398.1,398.1,0,0,0-33.771-24.552c-25.382-16.416-45.467-24.739-59.695-24.739-12.391,0-21.225,5.6-29.019,10.54-6.572,4.166-12.248,7.764-19.03,7.764-5.527,0-10.027-2.374-14.791-4.887-5.97-3.149-12.737-6.72-22.477-6.012C57.837,40.891,23.741,73.658,17.094,80.213l2.912,2.942C37.866,65.542,63.421,44.633,76.662,43.673Z",
    transform: "translate(-4.54 -9.071)",
    fill: "#006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.387,114.042a23.084,23.084,0,0,0,4.155-7.437,9.666,9.666,0,0,1,.957.934l3.136-2.7a16.852,16.852,0,0,0-2.833-2.5,45.845,45.845,0,0,0,1.123-7.123l-4.136-.252a42.578,42.578,0,0,1-.739,5.134,24.675,24.675,0,0,0-3.379-1.364,69.335,69.335,0,0,0,.791-11.385V85.107h-11.8v4.136H121.3a63.236,63.236,0,0,1-.718,8.634,13.608,13.608,0,0,0-9.157,2.186c-3.936,2.672-4.548,6.186-3.809,8.583a6.581,6.581,0,0,0,6.558,4.467,7.718,7.718,0,0,0,5.617-2.4c1.183-1.185,2.805-3.512,4.011-7.938l.173.06a21.174,21.174,0,0,1,3.015,1.352,20.123,20.123,0,0,1-3.715,7.121Zm-9.527-6.25a3.62,3.62,0,0,1-2.682,1.185,2.482,2.482,0,0,1-2.6-1.547c-.3-.986.109-2.541,2.179-3.947a9.3,9.3,0,0,1,5.323-1.565c.216,0,.43.006.642.017A13.56,13.56,0,0,1,116.86,107.792Z",
    transform: "translate(-29.795 -24.017)",
    fill: "#006"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.164,90V85.868h-7.216q0-1.945,0-1.943l-4.143,0s0,.646,0,1.939h-11.43V90h11.43c0,.5.043,5.165.048,5.551a6.481,6.481,0,1,0-2.7,12.366c.048,0,.094-.006.142-.007a12.536,12.536,0,0,1-2.641,2.647l2.491,3.306c7.076-5.314,6.954-12.551,6.836-19.549-.016-.9-.03-3.81-.03-4.313ZM154.8,101.44a2.35,2.35,0,1,1,2.351,2.345A2.351,2.351,0,0,1,154.8,101.44Z",
    transform: "translate(-41.274 -23.683)",
    fill: "#006"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.363,114.033l1.625,3.8A11.259,11.259,0,0,0,247.611,112a12.514,12.514,0,0,0,.061-9.712,9.237,9.237,0,0,0-7.343-5.473,12.813,12.813,0,0,0-11.71,4.542,12.575,12.575,0,0,0-1.849,12.631,4.907,4.907,0,0,0,4.326,3.191,6.82,6.82,0,0,0,4.735-2.092c2.727-2.654,4.112-7.4,4.126-14.137a5.064,5.064,0,0,1,3.867,2.871C245.772,108.693,243.066,112.882,240.363,114.033Zm-7.293-2.045a2.938,2.938,0,0,1-1.895,1.054h-.046c-.093-.029-.537-.387-.864-1.5a8.588,8.588,0,0,1,1.527-7.528,8.906,8.906,0,0,1,4.017-2.767C235.747,108.085,234.109,110.893,233.071,111.988Z",
    transform: "translate(-62.948 -27.278)",
    fill: "#006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.151,87.988h-4.143v26.958h4.143Z",
    transform: "translate(-52.364 -24.83)",
    fill: "#006"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.514,107.284v-.19c.938.49,1.724.955,2.2,1.262l2.242-3.478a36.172,36.172,0,0,0-4.446-2.387v-5.41H213.5V92.945h-2.982V88.721h3.355V84.585H199.487v4.136h6.884v4.224h-5.283v4.136h5.283v3.976a10.987,10.987,0,0,0-2.389-.293,6.457,6.457,0,0,0-6.533,6.521,6.532,6.532,0,0,0,13.065,0Zm-4.143,0a2.389,2.389,0,0,1-4.778,0,2.309,2.309,0,0,1,2.39-2.385,8.485,8.485,0,0,1,2.389.429Z",
    transform: "translate(-55.006 -23.869)",
    fill: "#006"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.029,94.963l-3.5.937,1.18,4.393,3.5-.937Z",
    transform: "translate(-49.711 -26.798)",
    fill: "#006"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.842,94.963l-3.5.937,1.735,6.463,3.5-.937Z",
    transform: "translate(-47.7 -26.798)",
    fill: "#006"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.483,160.714H61.1v-4.135H56.483V150.61h5.861v-4.135H56.483v-5.491H52.34v5.491H49.651a20.3,20.3,0,0,0,.231-3.038H45.739a19.523,19.523,0,0,1-4.36,11.685l1.549,1.372,1.545,1.378A23.7,23.7,0,0,0,48.6,150.61h3.74v5.969H47.72v4.135H52.34v5.817H42.928v4.136H65.717v-4.136H56.483v-5.817Z",
    transform: "translate(-11.336 -39.784)",
    fill: "#006"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.188,147.384v-6.359h-4.2v6.359c0,16.031-10.67,19.472-11.124,19.611l.594,1.981.582,1.985c.434-.127,8.246-2.538,12.047-11.992,3.8,9.454,11.612,11.865,12.047,11.992l1.164-3.969C27.189,166.959,16.188,163.557,16.188,147.384Z",
    transform: "translate(0 -39.796)",
    fill: "#006"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.016,156.151h5.35v-4.136h-5.35v-4.333h6.592v-4.136H178.217a16.487,16.487,0,0,0,.2-2.52h-4.143c0,6.546-5.4,11.467-5.455,11.516l2.758,3.087a21.12,21.12,0,0,0,2.608-2.924v7.718H170.2v4.136h10.675V170.9h4.143v-6.339h7.97v-4.136h-7.97v-4.271Zm-7.959-8.469h3.816v4.333h-6.194A22.427,22.427,0,0,0,177.057,147.681Zm1.268,12.74v-4.271h2.548v4.271Z",
    transform: "translate(-46.994 -39.796)",
    fill: "#006"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.681,140.983c-.858,3.786-5.768,7.051-5.822,7.073l1.587,3.821c.17-.07,3.525-1.97,4.235-3.952v22.959h4.4v-29.9Z",
    transform: "translate(-21.823 -39.784)",
    fill: "#006"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.368,140.279c-5.316,0-11.524,3.674-11.524,14.028v2.7c0,10.354,6.207,14.028,11.524,14.028s11.524-3.674,11.524-14.028v-2.7C120.891,143.953,114.683,140.279,109.368,140.279Zm7.121,16.732c0,6.032-2.662,9.634-7.121,9.634s-7.122-3.6-7.122-9.634v-2.7c0-6.032,2.663-9.634,7.122-9.634s7.121,3.6,7.121,9.634Z",
    transform: "translate(-27.135 -39.585)",
    fill: "#006"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.032,140.279c-5.316,0-11.524,3.674-11.524,14.028v2.7c0,10.354,6.207,14.028,11.524,14.028s11.524-3.674,11.524-14.028v-2.7C156.555,143.953,150.347,140.279,145.032,140.279Zm7.121,16.732c0,6.032-2.662,9.634-7.121,9.634s-7.122-3.6-7.122-9.634v-2.7c0-6.032,2.663-9.634,7.122-9.634s7.121,3.6,7.121,9.634Z",
    transform: "translate(-37.114 -39.585)",
    fill: "#006"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M297.736,140.6c-1.665,11.029-14.8,16.222-14.927,16.273l1.484,3.861a35.158,35.158,0,0,0,7.933-4.589q.549-.42,1.068-.854v15.49h4.143V151.061a20.964,20.964,0,0,0,4.4-9.85Z",
    transform: "translate(-78.89 -39.675)",
    fill: "#006"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.331,144.536h-9.495v4.136h9.495Z",
    transform: "translate(-59.311 -40.787)",
    fill: "#006"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.172,158.124h11.349c-.441,10.387-7.409,12.527-7.715,12.616l1.1,3.987c.429-.117,10.271-2.952,10.755-16.6h7.3v-4.135H209.172Z",
    transform: "translate(-58.286 -43.454)",
    fill: "#006"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336.047,154.466v-4.135h-8.324v-9.306H323.58v9.306H313.258v4.135h10.3c-.441,10.387-7.409,12.527-7.715,12.616l1.1,3.987c.429-.117,10.271-2.952,10.755-16.6Z",
    transform: "translate(-87.41 -39.796)",
    fill: "#006"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M357.994,164.777H344.762v4.135h13.232Z",
    transform: "translate(-96.226 -46.499)",
    fill: "#006"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M265.464,149.183h-4.143v2.293h-5.3v-6.391h-4.143v6.391h-4.564v4.135h4.564v5.318h4.143v-5.318h5.28c-.442,10.387-7.41,12.528-7.716,12.616l.56,1.991.543,2c.429-.117,10.271-2.952,10.755-16.6h4.66v-4.135h-4.637v-2.293Z",
    transform: "translate(-68.958 -40.942)",
    fill: "#006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.354,140.372l-3.5.937,1.734,6.462,3.5-.937Z",
    transform: "translate(-65.472 -39.612)",
    fill: "#006"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M231.162,140.372l-3.5.937,1.735,6.462,3.5-.937Z",
    transform: "translate(-63.459 -39.612)",
    fill: "#006"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M276.494,140.372l-3.5.937,1.735,6.462,3.5-.937Z",
    transform: "translate(-76.144 -39.612)",
    fill: "#006"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M269.3,140.372l-3.5.937,1.331,4.959,3.5-.937Z",
    transform: "translate(-74.131 -39.612)",
    fill: "#006"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogo);
export default __webpack_public_path__ + "static/media/site_logo.db32c4c2319121fc277acad09d47944b.svg";
export { ForwardRef as ReactComponent };